var map = {
	"./add_black.svg": 75792,
	"./add_on.svg": 59052,
	"./add_on_select.svg": 13727,
	"./all.svg": 97183,
	"./arrow_down.svg": 25421,
	"./arrow_down_black.svg": 51491,
	"./arrow_right.svg": 10553,
	"./arrow_right_424242.svg": 79050,
	"./arrow_right_black.svg": 52786,
	"./arrow_up.svg": 97594,
	"./arrow_white.svg": 40570,
	"./back.svg": 60576,
	"./back_to_top.svg": 70266,
	"./bag-dark.svg": 57514,
	"./bag.svg": 53274,
	"./bell.svg": 17291,
	"./cart.svg": 78120,
	"./checkbox-checked.svg": 12963,
	"./checkbox-uncheck.svg": 11615,
	"./choose_word.svg": 38872,
	"./circle_add.svg": 41497,
	"./circle_close.svg": 83495,
	"./circle_edit.svg": 77595,
	"./circle_favorite.svg": 41356,
	"./circle_unfavorite.svg": 7780,
	"./clock.svg": 7705,
	"./close.svg": 11422,
	"./close_black.svg": 48170,
	"./close_light.svg": 60560,
	"./close_white.svg": 5213,
	"./complete_word.svg": 33361,
	"./copy.svg": 1818,
	"./copy2.svg": 73305,
	"./copy3.svg": 49987,
	"./cup.svg": 62131,
	"./delete_word.svg": 85266,
	"./edit.svg": 90519,
	"./facebook.svg": 1243,
	"./facebook_login.svg": 6318,
	"./favorite.svg": 53248,
	"./footer-logo.svg": 26313,
	"./garbage-can.svg": 22890,
	"./gift.svg": 19368,
	"./giveaway_big.svg": 13605,
	"./giveaway_black.svg": 29302,
	"./giveaway_gray.svg": 76608,
	"./heart.svg": 59168,
	"./instagram.svg": 77770,
	"./left.svg": 84506,
	"./like.svg": 53072,
	"./line.svg": 4899,
	"./line_login.svg": 64967,
	"./maps.svg": 33573,
	"./menu.svg": 74469,
	"./modal-close.svg": 69809,
	"./package.svg": 13783,
	"./pencil.svg": 33225,
	"./plus.svg": 73701,
	"./profile.svg": 28886,
	"./pwd_hide.svg": 20422,
	"./pwd_show.svg": 35019,
	"./question-circle.svg": 98175,
	"./radio-selected.svg": 91208,
	"./radio-unselected.svg": 40615,
	"./red-bag.svg": 57945,
	"./right.svg": 32198,
	"./search.svg": 5193,
	"./selected.svg": 71667,
	"./selected_white.svg": 37492,
	"./swiper-left-active.svg": 23769,
	"./swiper-right-active.svg": 54972,
	"./tag.svg": 999,
	"./tag_gold.svg": 98302,
	"./trash-regular.svg": 7186,
	"./unlike.svg": 32155,
	"./zoom-in.svg": 32941,
	"./zoom-out.svg": 39640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9184;